export const PROVIDER_BASE_URL    = '/';
export const MED_SERVICE_BASE_URL = 'http://localhost:4006';
export const CONFERENCE_STARTED_EVENT = 'Conference Started';
